export default {
  NODE_ENV: "development",
  API_URL: "http://127.0.0.1:4090",
  TG_BOT_URL: "https://t.me/ShonovBot",
  MAX_BOT_URL: "https://max.ru/id7814466467_2_bot",
};
